var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoCollapsed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.73926 0H4.73926V5H9.73926V0Z",
    fill: "url(#paint0_linear_5626_117103)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4814 0H9.48145V5H14.4814V0Z",
    fill: "url(#paint1_linear_5626_117103)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2236 0H14.2236V5H19.2236V0Z",
    fill: "url(#paint2_linear_5626_117103)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.2227H0V19.2227H5V14.2227Z",
    fill: "url(#paint3_linear_5626_117103)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.48145H0V14.4814H5V9.48145Z",
    fill: "url(#paint4_linear_5626_117103)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5 4.73926H0V9.73926H5V4.73926Z",
    fill: "url(#paint5_linear_5626_117103)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14.4834H19V19.4834H24V14.4834Z",
    fill: "url(#paint6_linear_5626_117103)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24 9.74219H19V14.7422H24V9.74219Z",
    fill: "url(#paint7_linear_5626_117103)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24 5H19V10H24V5Z",
    fill: "url(#paint8_linear_5626_117103)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73926 18.9619H4.73926V23.9619H9.73926V18.9619Z",
    fill: "url(#paint9_linear_5626_117103)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4814 18.9619H9.48145V23.9619H14.4814V18.9619Z",
    fill: "url(#paint10_linear_5626_117103)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2236 18.9619H14.2236V23.9619H19.2236V18.9619Z",
    fill: "url(#paint11_linear_5626_117103)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5626_117103",
    x1: -6.14025,
    y1: 16.8041,
    x2: 14.4429,
    y2: -5.20619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5626_117103",
    x1: -3.73054,
    y1: 19.2977,
    x2: 16.8526,
    y2: -2.70941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5626_117103",
    x1: -1.32083,
    y1: 21.7913,
    x2: 19.2623,
    y2: -0.215837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5626_117103",
    x1: -1.06637,
    y1: 20.5339,
    x2: 19.5167,
    y2: -1.47644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5626_117103",
    x1: -3.55992,
    y1: 18.4602,
    x2: 17.0232,
    y2: -3.55013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5626_117103",
    x1: -6.05348,
    y1: 16.3855,
    x2: 14.5296,
    y2: -5.62479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5626_117103",
    x1: 8.60696,
    y1: 30.7688,
    x2: 29.1901,
    y2: 8.75852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5626_117103",
    x1: 6.1134,
    y1: 28.6951,
    x2: 26.6933,
    y2: 6.68484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5626_117103",
    x1: 3.61662,
    y1: 26.6205,
    x2: 24.1997,
    y2: 4.6134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5626_117103",
    x1: 3.8372,
    y1: 25.1024,
    x2: 24.4203,
    y2: 3.09206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5626_117103",
    x1: 6.24369,
    y1: 27.5959,
    x2: 26.8268,
    y2: 5.58562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5626_117103",
    x1: 8.65341,
    y1: 30.0895,
    x2: 29.2365,
    y2: 8.0792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCollapsed);
export default __webpack_public_path__ + "static/media/logo_collapsed.c21bb12e7a8f7b50304963430e1b9dc5.svg";
export { ForwardRef as ReactComponent };